import { useUserSession } from "../context/UserContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { WorkspaceRole } from "../types";

export function useCanManageWorkspace(workspaceId: string): boolean {
  const { userSession } = useUserSession();
  const { activeWorkspace } = useWorkspace();
  return Boolean(
    userSession?.user.email &&
    (userSession.user.isAdmin === true ||
      (activeWorkspace?.workspaceId === workspaceId &&
        (activeWorkspace.role === WorkspaceRole.Owner ||
          activeWorkspace.role === WorkspaceRole.Administrator))),
  );
}
